/**
 * Virtual console log level.
 *
 * @see https://console.spec.whatwg.org/#loglevel-severity
 */
enum VirtualConsoleLogLevelEnum {
	log = 0,
	info = 1,
	warn = 2,
	error = 3
}
export default VirtualConsoleLogLevelEnum;
